import React, { useState } from 'react';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { sendContact } from '../../api/contact';
import SectionTitle from '../SectionTitle/SectionTitle';
import Button from '../Button/Button';
import COS_LOGO_ROUND from '../../images/COS_LOGO_ROUND.png';
import './JoinForm.css';

const JoinForm = ({ classname }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { handleSubmit, register, errors, reset } = useForm();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [messageSent, setMessageSent] = useState(false);
  const onSubmit = async (values) => {
    setIsSubmitting(true);
    const recaptchaToken = await executeRecaptcha('contact_form');
    const response = await sendContact({ ...values, recaptchaToken });
    setIsSubmitting(false);
    if (response.ok) {
      reset();
      setMessageSent(true);
      setTimeout(function () {
        setMessageSent(false);
      }, 5000);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      noValidate
      className={clsx('JoinForm', { [classname]: classname })}
    >
      <img
        src={COS_LOGO_ROUND}
        className="JoinForm__logo"
        alt="smile"
        loading="lazy"
      />
      <SectionTitle>
        Écrivez<strong className="SectionTitle__item--bold">-nous</strong>
      </SectionTitle>
      <div className="JoinForm__field">
        <label className="JoinForm__label" htmlFor="name">
          Nom
        </label>
        <input
          type="text"
          className={clsx('JoinForm__input', {
            'JoinForm__input--error': errors.name,
          })}
          id="name"
          name="name"
          placeholder="Votre nom"
          ref={register({
            required: 'Obligatoire',
          })}
        />
        <div className="JoinForm__error">
          {errors.name && errors.name.message}
        </div>
      </div>
      <div className="JoinForm__field">
        <label className="JoinForm__label" htmlFor="email">
          Email
        </label>
        <input
          type="email"
          className={clsx('JoinForm__input', {
            'JoinForm__input--error': errors.email,
          })}
          id="email"
          name="email"
          placeholder="Votre e-mail"
          ref={register({
            required: 'Obligatoire',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              message: 'Adresse email invalide',
            },
          })}
        />
        <div className="JoinForm__error">
          {errors.email && errors.email.message}
        </div>
      </div>
      <div className="JoinForm__field">
        <label className="JoinForm__label" htmlFor="phone">
          Téléphone
        </label>
        <input
          type="text"
          inputMode="tel"
          className={clsx('JoinForm__input', {
            'JoinForm__input--error': errors.phone,
          })}
          id="phone"
          name="phone"
          placeholder="Votre téléphone"
          ref={register}
        />
        <div className="JoinForm__error"></div>
      </div>
      <div className="JoinForm__field">
        <label className="JoinForm__label" htmlFor="message">
          Message
        </label>
        <textarea
          className={clsx('JoinForm__text-area', {
            'JoinForm__text-area--error': errors.message,
          })}
          id="message"
          name="message"
          placeholder="Votre message"
          ref={register({
            required: 'Obligatoire',
          })}
        />
        <div className="JoinForm__error">
          {errors.message && errors.message.message}
        </div>
      </div>
      <Button
        disabled={Object.entries(errors).length !== 0 || isSubmitting}
        loading={isSubmitting}
        classname="JoinForm__button"
        grey={true}
        type="submit"
      >
        Envoyer
      </Button>

      <div className="JoinForm__success">
        {messageSent && 'Votre message a bien été envoyé à COS !'}
      </div>
    </form>
  );
};

export default JoinForm;
